var map = {
	"./MDA_LOGO.png": "6064",
	"./battery-active.png": "1129",
	"./battery-cabinet.png": "3dd7",
	"./battery-offline.png": "beff",
	"./battery-offline2.png": "cfb4",
	"./battery-online.png": "11c7",
	"./battery-overdue.png": "8ec5",
	"./battery-user.png": "e1ef",
	"./bike-offline.png": "d332",
	"./bike-online.png": "e438",
	"./box-offline.png": "c211",
	"./box-online.png": "6f87",
	"./cpbox-offline.png": "019c",
	"./cpbox-online.png": "7cd6",
	"./ddc.png": "8b75",
	"./login_bg.png": "bfbd",
	"./login_bg_new.png": "a8df",
	"./pile-active.png": "920b",
	"./pile-offline.png": "5afb",
	"./pile-online.png": "6155",
	"./stat/b1.png": "19a0",
	"./stat/b2.png": "56d5",
	"./stat/b3.png": "c142",
	"./stat/bg.png": "ba53",
	"./stat/empty.png": "9e31",
	"./stat/l1.png": "a3d7",
	"./stat/l2.png": "2841",
	"./stat/l3.png": "feaf",
	"./stat/l4.png": "d1d5",
	"./stat/l5.png": "bbaa",
	"./stat/l6.png": "be74",
	"./stat/r1.png": "4563",
	"./stat/r2.png": "3f48",
	"./stat/r3.png": "155a",
	"./stat/r4.png": "757b",
	"./stat/r5.png": "4aea",
	"./stat/r6.png": "2c34",
	"./stat/title.png": "bd29"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";